module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0006.jpg?v=2143f6af";